import { emptyImageIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import HtmlContent from '../HtmlContent'
import style from './styles/news.module.scss'

interface IProps {
  title: string
  text: string
  date: string
  image: string | undefined
  url: string
  bigCard?: boolean
}

const CheckImage = ({ image }): React.ReactElement => {
  if (image === undefined) {
    return (
      <div className={style.card__placeholder}>
        <GxIcon src={emptyImageIcon} className={style.card__placeholder_icon} />
      </div>
    )
  } else {
    return (
      <img
        src={image}
        width='705px'
        height='438px'
        alt='Превью новости'
        className={style.card__image}
      />
    )
  }
}

const NewsCard = ({
  title,
  text,
  date,
  image,
  url,
  bigCard = false
}: IProps): React.ReactElement => {
  return (
    <a
      href={url}
      className={classNames({
        [style.card]: true,
        [style['card--big']]: bigCard,
        [style['card--small']]: !bigCard
      })}
    >
      {bigCard
        ? (
          <div className={style.card__image_wrap}>
            <CheckImage image={image} />
          </div>
          )
        : (
          <CheckImage image={image} />
          )}
      <div className={style.card__content}>
        <span className={style.card__date}>{date}</span>
        <h3 className={style.card__title}>{title}</h3>
        <HtmlContent className={style.card__text} content={text} />
      </div>
    </a>
  )
}

export default NewsCard
